import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/cre-app/client/app/layouts/default.vue").then(m => m.default || m)),
  events: defineAsyncComponent(() => import("/cre-app/client/app/layouts/events.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("/cre-app/client/app/layouts/landing.vue").then(m => m.default || m))
}